import { Component, ElementRef, HostListener } from '@angular/core';
import { Icons } from '../../../shared/helpers/icons';
import { LucideAngularModule } from 'lucide-angular';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tip-assistant',
  standalone: true,
  imports: [
    LucideAngularModule,
    CommonModule
  ],
  templateUrl: './tip-assistant.component.html',
  styleUrl: './tip-assistant.component.css'
})
export class TipAssistantComponent {

  icons = Icons;
  showChatbox: boolean = false;

  constructor(
    private elementRef: ElementRef
  ) {}

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.onClose(); 
    }
  }

  openChatbox(): void {
    this.showChatbox = !this.showChatbox;
  }
  
  onClose(): void {
    this.showChatbox = false;
  }
}
